// Grouped client for Files operations
import { ApiConfiguration } from '../ApiConfiguration';
import { FinishUploadResponse } from '../models/FinishUploadResponse';
import { PrepareUploadResponse } from '../models/PrepareUploadResponse';
import { FinishUploadResponseSerializer } from '../serializers/FinishUploadResponseSerializer';
import { PrepareUploadResponseSerializer } from '../serializers/PrepareUploadResponseSerializer';

/**
 * HTTP client for Files operations
 *
 * Client for Files operations
 */
export class FilesClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  /**
   * Finish Upload
   * FinishUpload
   * @param id Remote File Id
   * @param options Optional request options (additional headers, etc.)
   */
  async finishUpload(id: string, options?: { headers?: Record<string, string> }): Promise<FinishUploadResponse> {
    let path = '/files/api/File({id})/Upload'
      .replace('{id}', encodeURIComponent(String(id)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PUT',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FinishUploadResponseSerializer.fromObject(data);
  }

  /**
   * Get Pre-signed Url to Upload File Contents
   * PrepareUpload
   * @param id Remote File Id
   * @param options Optional request options (additional headers, etc.)
   */
  async prepareUpload(id: string, options?: { headers?: Record<string, string> }): Promise<PrepareUploadResponse> {
    let path = '/files/api/File({id})/Upload'
      .replace('{id}', encodeURIComponent(String(id)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return PrepareUploadResponseSerializer.fromObject(data);
  }

}
